import {
  CaseStatus,
  CaseForm,
  caseStatus,
  DiagnosisForm,
  Action,
  CaseStatusEnum,
} from 'queries/cases/types';
import { FieldValues, UseFormGetValues } from 'react-hook-form';
export const requiredFieldsByStage: Record<CaseStatus, Array<keyof CaseForm>> = {
  [caseStatus.diagnosis]: [
    'diagnosis',
    'detection_method',
    'dimension',
    'anomaly_start',
    'severity',
  ],
  [caseStatus.actions]: [],
  [caseStatus.feedback]: ['feedback_comments', 'anomaly_end', 'conclusion'],
  [caseStatus.closed]: [],
  [caseStatus.canceled]: [],
};
export const getIsStageFilled = (getValues: UseFormGetValues<FieldValues>, stage: CaseStatus) => {
  if (stage === caseStatus.actions) {
    return (getValues('actions') ?? [])?.every(
      (action: Action) => action.status === 'executed' || action.deleted,
    );
  }
  return requiredFieldsByStage[stage].every(
    (field) => getValues(field as keyof DiagnosisForm) !== '',
  );
};
export const getIsPreviousStepFilled = (
  getValues: UseFormGetValues<FieldValues>,
  stepName: CaseStatus,
) => {
  const previousStepNumber = CaseStatusEnum[stepName] - 1;
  const previousStepName = Object.keys(CaseStatusEnum).find(
    (key) => CaseStatusEnum[key as CaseStatus] === previousStepNumber,
  );
  return previousStepName ? getIsStageFilled(getValues, previousStepName as CaseStatus) : false;
};
